export default {
    global: {
        close: 'Kapat',
        save: 'Kaydet',
        continue : 'Devam et',
        confirmAndSend: 'Onayla ve gönder',
        mandatory_field: 'Bu alan zorunludur',
        checkbox_mandatory : 'Bu onay kutusu gereklidir',
        cancel: 'İptal',
        ok: 'Tamam',
        yes: 'Evet',
        no: 'hayır',
        post_success: 'Veriler iyi gönderildi',
        code : 'KOD:'
    },
    menu: {

        main_menu: 'Ana menü',
        lmra: 'LMRA\'yı Aç/Kapa',
        report_incident: 'Olay bildir',
        report_near_incident: 'Yakın bir olayı bildirin',
        risk_analysis: 'Risk analizi',
        corona_analysis: 'Korona analizi',
        scan_qr: "ETİKET/QR-KODU tara",
        process_issue: "İşlem sorununu bildir",
        checklist: "Kontrol listesini görüntüle",
        log_in: "Giriş yap",
        log_out: "Çıkış yap",
        emergency_numbers : "Acil durum numaraları",
        project_documentation : "Proje belgeleri"
    },
    default_lrma: {
        what_label: 'Ne yapacağımı anlıyor muyum?',
        how_label: 'Nasıl yapacağımı biliyor muyum?',
        risk_label: 'Tehlikeleri ve riskleri tanıyor muyum?',
        control_label: 'Kontrol edebilir miyim?',
        default_pbm_label: 'Doğru KKD\'ye sahip miyim?',
        default_pbm_question: 'Doğru KKD\'ye sahip miyim?|1',
        lmra_job_state_positive: 'Tamam, işe başlamak için, değişiklikler meydana geldiğinde LMRA\'yı gözden geçireceğiz',
        lmra_job_state_negative: 'Henüz işe başlamadık.',
    },
    static_three_state_lmra: {
        get_data_title: "En son sürüm indiriliyor.",
        can_not_load_newest_list_title: "Dikkat",
        can_not_load_newest_list: 'En son liste alınırken bir şeyler ters gitti. Devam edebilmeniz için listenin daha eski bir kayıtlı sürümü görüntülenecektir. Bu sorun devam ederse, sorumlu bir kişiye haber vermek en iyisidir.',
    },
    private_location: {
        title: 'Özel bir yerde misiniz?',
        body: 'Özel konumlar, işle ilgili yerlerin dışındaki konumlardır.'
    },
    remarks: {
        remarksDialogTitle: 'Açıklamalar?',
        remarksDialogPlaceholder: 'Açıklamalarınızı buraya yazın',
    },
    start_stop_screen: {
        start_work_btn: "çalışmaya başla",
        stop_work_btn: "çalışmayı durdur",
    },
    work_report: {
        title: "Çalışma raporu",
        placeholder: "İş raporunuzu buraya yazın",
        skip_work_report: "Atla",
        buildingListTitle : "Çalışma raporu formunuzu oluşturuyoruz, bu çok uzun sürmez.",
        criticalErrorTitle: 'Hata:',
        criticalErrorBody: 'Çalışma raporu formunuzu oluştururken bir şeyler ters gitti! Lütfen yöneticinize aşağıdaki hata kodunu bildirin:',
    },
    incident_report: {
        title: "Olay bildir",
        placeholder: "Ne oldu?",
    },
    oeps_report: {
        title: "Yakın olay bildir",
        placeholders: {
            machine: 'Hangi makine?',
            who: 'Kim dahil oldu?',
            what: 'Ne oldu?',
            how: 'Nasıl oldu / bu nasıl oldu?',
            stop_card: 'Durum Kartı Seç',
            location: 'Konum seç',
            department: 'Departman seçin'
        },
        external_employee: 'Harici bir çalışan mı',
        when_text_label: 'Bu ne zaman oldu?',
        change_date_time_btn: 'Tarihi / saati değiştir'
    },
    risk_analysis: {
        title: {
            risk_default: "Risk analizi",
            risk_default_sub_title: '',
            corona: "Korona analizi",
            corona_sub_title: 'Çalışma koşullarınızı aşağıda belirtin ve nasıl güvenli çalışacağınızı öğrenin.'
        },
        lists: {
            risk_default: {
                gravity: {
                    label: 'Yerçekimi',
                    gravity_01: 'küçük, devamsızlık olmadan yaralanma',
                    gravity_02: 'önemli, yaralanma ve devamsızlık',
                    gravity_07: 'ağır, kalıcı sakatlık / (kısmi) iş göremezlik içeren kronik durumlar',
                    gravity_15: 'çok ciddi, 1 ölü (uzun vadede akut)',
                    gravity_40: 'felaket, birden fazla ölüm'
                },
                probability: {
                    label: 'Olasılık',
                    probability_0_1: 'hayal etmek neredeyse imkansız',
                    probability_0_2: 'pratik olarak imkansız',
                    probability_0_5: 'hayal edilebilir, ancak olası değil',
                    probability_01: 'olası olmayan, sınırda bir durum',
                    probability_03: 'olağandışı, ancak mümkün',
                    probability_06: 'oldukça mümkün',
                    probability_10: 'beklenen'
                },
                exposure: {
                    label: 'Maruziyet',
                    exposure_0_5: 'çok nadir (yılda 1 kez)',
                    exposure_01: 'nadiren (yıllık)',
                    exposure_02: 'bazen (aylık)',
                    exposure_03: 'ara sıra (haftalık)',
                    exposure_06: 'düzenli (günlük)',
                    exposure_10: 'sürekli',
                },
            },
            corona: {
                distance: {
                    label: 'Benimle diğerleri arasında beklenen mesafe:',
                    distance_01: 'D > 8 m',
                    distance_02: '6 m < D < 8 m',
                    distance_07: '2 m < D < 6 m',
                    distance_15: '1,5 m < D < 2 m',
                    distance_40: '1 m < D < 1,5 m',
                    distance_100: 'D < 1 m'
                },
                probability: {
                    label: 'Diğerlerinin...',
                    probability_0_1: 'FFP2 maskesi + gözlük + koruyucu kıyafet giyin',
                    probability_0_2: 'FFP2 maskesi + gözlük takın',
                    probability_0_5: 'maske veya yüz siperi takın',
                    probability_01: 'Kesinlikle Corona Yönergelerine uyun',
                    probability_03: 'belki Corona Yönergelerine saygı gösterin',
                    probability_06: 'bazı Corona Yönergelerini ihlal et',
                    probability_10: 'Birden çok Corona Yönergesini ihlal etti'
                },
                exposure: {
                    label: 'Beklenenden daha yakın temas olasılığı:',
                    exposure_0_5: 'Çok olası',
                    exposure_01: 'Birkaç şey ters gittiğinde',
                    exposure_02: 'Belirli şeyler ters giderse olağandışı',
                    exposure_03: 'Muhtemelen, şans o kadar büyük değil',
                    exposure_06: 'Oldukça mümkün, makul bir şans',
                    exposure_10: 'Beklenen, neredeyse kesinlikle',
                },
            },
        },
        results: {
            risk_default: {
                kinneyCode1: 'yok',
                kinneyCode2: 'dikkat gerekli',
                kinneyCode3: 'gerekli önlemler planlanabilir',
                kinneyCode4: 'anında iyileştirme',
                kinneyCode5: 'çalışmayı bırak'
            },
            corona: {
                kinneyCode1: 'Kabul edilebilir risk: Ek koruyucu önlem gerekli değildir',
                kinneyCode2: 'Olası risk: Dikkat edilmesi gerekiyor',
                kinneyCode3: 'Büyük risk: Koruyucu önlemler alın',
                kinneyCode4: 'Yüksek risk: Daha fazla koruyucu önlem alın',
                kinneyCode5: 'Çok yüksek risk: Aktiviteyi ayarlamaya çalışın, mümkün değilse maksimum koruyucu önlemleri alın'
            },
        },
        supportive_texts: {
            risk_default: {
                supportiveText1: '',
                supportiveText2: '',
                supportiveText3: '',
                supportiveText4: '',
                supportiveText5: ''
            },
            corona: {
                supportiveText1: 'Çalışma ortamımda geçerli olan Corona Yönergelerini biliyor ve saygı duyuyorum.',
                supportText2: 'Geçerli olan Corona kurallarını biliyorum ve bunlara saygı duyuyorum. Çalışma ortamımdaki insanlardan da Corona kurallarına uymalarını özellikle rica ediyorum. Daha fazla ek koruyucu önlem gerekli değildir.',
                supportText3: 'Etkinliğin başında ve sonunda ellerimi dezenfekte ettim veya dezenfekte ettim. (Güvenlik) gözlükleriyle birlikte yüz siperi veya uygun bir ağız maskesi takıyorum. Çalışma ortamımdaki insanlar en azından yüz siperi veya burun maskesi (tercihen koruyucu gözlükle birlikte) takmalıdır. Bu toplu koruma ekipmanlarını nasıl doğru kullanacağımı ve pratikte nasıl uygulayacağımı biliyorum. Geçerli olan Corona Yönergelerini biliyor ve saygı duyuyorum ve çalışma ortamımdaki kişilerin de Corona Yönergelerine uymalarını açıkça rica ediyorum.',
                supportText4: 'Etkinliğin başında ve sonunda ve güvenli olmayan herhangi bir dokunuştan sonra ellerimi dezenfekte ettim veya dezenfekte ettim. Yüz siperi veya gözlükle birlikte koruyucu ağız burun maskesi (tercihen FFP2 solunum koruma maskesi) takıyorum. Bu kişisel koruyucu ekipmanları (KKD) nasıl doğru kullanacağımı ve pratikte nasıl uygulayacağımı biliyorum. Çalışma ortamında geçerli olan korona yönergelerini biliyorum ve elbette bu Corona yönergelerine uymaya devam ediyorum. Çalışma ortamımdaki insanlardan da gerekli güvenlik önlemlerini almalarını ve Corona kurallarına uymalarını rica ediyorum.',
                supportiveText5: 'Öncelikle, diğer kişilerle doğrudan temas olmaksızın faaliyetin başka bir şekilde gerçekleştirilip gerçekleştirilemeyeceğini düşünürüm. Bu mümkün değilse, mümkün olan tüm güvenlik önlemlerini alacağım. Faaliyetin başında ve sonunda ellerimi dezenfekte ettim veya dezenfekte ettim. Koruyucu eldiven giyiyorum. Yüz siperi veya koruyucu gözlük ve koruyucu giysi ile birlikte bir solunum koruma maskesi (en az FFP2) takıyorum. Bu kişisel koruyucu ekipmanları (KKD) nasıl doğru kullanacağımı ve pratikte nasıl uygulayacağımı biliyorum. Çalışma ortamında geçerli olan korona yönergelerini biliyorum ve elbette bu Corona yönergelerine uymaya devam ediyorum.. Çalışma ortamımdaki kişilerin de gerekli güvenlik önlemlerini almalarını ve Corona yönergelerine dikkatle uymalarını rica ediyorum.'
            }
        },
        leave_warning: {
            risk_default: {
                title: 'Dikkat',
                body: 'Mevcut risk analizi raporunu göndermeden bu pencereyi kapatmak üzeresiniz. Sayfadan ayrılmak istediğinizden emin misiniz?'
            },
            corona: {
                title: 'Dikkat',
                body: 'Mevcut Corona analiz raporunu göndermeden bu pencereyi kapatmak üzeresiniz. Sayfadan ayrılmak istediğinizden emin misiniz?'
            }
        },
        report_title: 'Analiz raporu',
        placeholder_report: 'Durumu açıklayın / açıklayın'
    },
    process_issue: {
        title: "Bir İşlem Sorunu Bildirin",
        placeholders: {
            issue_type_select: 'Sorun türünü seçin',
            failure_detail: 'Sorun ayrıntısını seçin',
            who: 'Kim dahil oldu?',
            description: 'sorunu tanımlayın',
            cnf: 'CNF?',
            comment: 'Ek açıklamalar / Yorumlar',
            other: 'Diğer'
        }
    },
    checklist: {
        getting_data_title: "En son kontrol listesi toplanır."
    },
    data_transfer: {
        post_busy: 'Lütfen bekleyin, veriler gönderiliyor.',
        post_success: 'Veriler iyi gönderildi.'
    },
    gdpr_disclaimer: {
        title: 'GDPR Önerisi:',
        body: 'lmra-first uygulamasının bir öğesinin gönderilmesi, aşağıdaki öğeler veritabanında saklanacaktır: mevcut konum (GPS - koordinatlar (onaylandıktan sonra)) ve tam zaman (ve yalnızca o zaman). Bu öğelerin hiçbiri diğer taraflara, kuruluşlara satılmayacaktır. Depolanan veriler sadece proje ve ilgili çalışma koşullarına göre kullanılacaktır.',
        accept_btn: 'Kabul ediyorum',
        decline_btn: 'Uygulamadan çık'
    },
    data_notice: {
        button_text: 'Bu bilgilerle ne olur?',
        popup_title: '',
        popup_body: ''
    },
    cap_settings: {
        alert_cn_pid_nf_title: 'Hata, bir şey unutmuşsunuz gibi görünüyor:',
        alert_cn_pid_nf_body: 'Müşteri adı ve/veya Proje Kimliği doldurulmadı, lütfen değerleri kontrol edin',
        client_select_placeholder: 'Bir müşteri seçin',
        project_select_placeholder: 'Bir Proje Seçin',
        client_not_in_list_label : 'müşteri listede yok',
        project_not_in_list_label : 'proje listede yok',
        client_name: 'Müşteri adı',
        proje_id: 'Proje Kimliği',
        project_distance: 'Proje Mesafesi',
        project_shift: 'Proje Geçişi',
        user_initials: 'Baş harfleriniz',
        project_tag_code_label: 'Proje TAG-Kodu',
        warning: {
            intro: 'Şu anda manuel giriş kullanıyorsunuz',
            Reason_server: 'çünkü sunucu verileri yüklenemedi!',
            Reason_client_not_listed: 'çünkü müşteri mevcut listede değildi!',
            Reason_project_not_listed: 'çünkü proje mevcut listede değildi!',
            dbl_check: 'Kaydetmeden önce tüm değerlerinizi iki kez kontrol edin!',
            admin_msg: 'Bu mesaj görünmeye devam ederse yöneticinizle iletişime geçin ve bunu bildirin!'
        },
        input_errors: {
            no_client_selected: 'Lütfen bir müşteri seçin',
            no_project_selected: 'Lütfen bir proje seçin',
        },
        loading_cap: 'Sunucudan veri yükleniyor',
        custom_shifts_labels: {
            open_field : 'Açık alan'
        },
        rrqrcode:{
            scan_error_invalid_format : {
                title : "Tarama hatası",
                body : "Geçersiz QR Veri biçimi algılandı"
            },
            error_popup_notice_manual_mode : {
                title : "Bir şeyler ters gitti",
                body : "RRQRCode verileri yüklenirken bir şeyler ters gitti, manuel moda geçiliyor"
            }
        }
    },
    tag_code_scanner: {
        global: {
            loading_stream: 'Kamera akışı yükleniyor...',
            default_error_button_test: 'Çıkış'
        },
        overlay_view: {
            title: 'Etiketi Tara - Kod',
            info_manual: 'Taramada sorun mu yaşıyorsunuz? Manuel girişi kullan',
            manual_btn: 'Manuel girişi etkinleştir.',
            errors: {
                invalid_tag_title: 'Geçersiz ETİKET KODU',
                invalid_tag_body: 'Taradığınız Kod geçerli bir ETİKET KODU değil, geçerli bir ETİKET KODU tarayın veya manuel girişe geçin.',
                error_btn_txt: 'Manuel Girişi Etkinleştir'
            }
        }
    },
    errors: {
        checklistNotLoaded: 'Listeyi alırken bir şeyler ters gitti, lütfen daha sonra tekrar deneyin.',
        EmergencyNumbersOverviewNotLoaded: 'Listeyi alırken bir şeyler ters gitti, lütfen daha sonra tekrar deneyin.',
        missing_critical_resource_title: 'Veri yüklenirken hata oluştu:',
        missing_critical_resource: 'Uygulamada bir kaynak eksik. Aşağıdaki kodu yöneticiye bildirin.',
        app_corrupt: 'Uygulama yapılandırmasının bozuk olduğu görülüyor. Lütfen yöneticinizle iletişime geçin.',
        data_save_failed: 'Veriler gönderilemedi, lütfen daha sonra tekrar deneyin...',
        camera: {
            NotAllowedError: 'HATA: Kamera erişimi için izin vermelisiniz',
            NotFoundError: 'HATA: Bu cihazda kamera yok',
            NotSupportedError: 'HATA: güvenli bağlam gerekli (HTTPS, localhost)',
            NotReadableError: 'HATA: Kamera zaten kullanılıyor mu?',
            OverconstrainedError: 'HATA: Kurulu kameralar uygun değil',
            StreamApiNotSupportedError: 'HATA: Akış API\'si bu tarayıcıda desteklenmiyor',
        },
        no_internet: 'Oooops ... Çevrimdışısınız, internet bağlantınızı kontrol edin!',
        input_validation: {
            char_limit: 'Maksimum %n karaktere izin verilir'
        },
        auth0 :{
            unverified_email : {
                error: 'Hata: E-posta adresi doğrulanmadı! E-postalarınızı kontrol edin!',
                info : 'Bu uygulamaya erişmek için <b>e-posta adresinizi doğrulamanız gerekiyor</b>.<br/><br/>Kısa süre içinde <b>bir e-posta alacaksınız</b> <b > |SENDER| </b><br/><br/><i>E-posta adresinizi doğrulamak için. E-postadaki talimatları uygulayın</i>'
            }
        }
    },
    noDataText: "Veri mevcut değil ...",
    defaultDynamicQuestion: '{"dynamic_questions":[{"id":null,"question":"Doğru KKD\'ye sahip miyim?","correct_answer":"1"}]}',
    auth : {
        emailLabel: 'E-posta',
        passwordLabel : 'Şifre',
        rememberMeLabel : "Beni hatırla",
        logInBtn: "Giriş yap",
        logOutBtn: "Çıkış yap",
        correctMFABtn: "Doğrula",
        errorPopupTitle: "Hata",
        acceptIdentify : "Hala Sen?",
        errors :{
            required : "Gerekli",
            invalidEmail : "Geçersiz e-posta",
            unknownError : "Bilinmeyen bir hata oluştu"
        },
        registerNewAccountBtn : "Yeni bir hesap oluştur.",
        forgotPassword : "Şifremi unuttum"
    },
    lmraComponent : {
        loadingProjectData : 'LMRA formunuz hazırlanıyor, lütfen bekleyin',
        startWorkQrDialog:{
            title : "Başlatma yöntemini seçin:",
            body : "Risk refleksi QR kodunuz varsa, lütfen QR Kodunu seçin, aksi halde Manuel giriş yöntemini kullanın",
            positive_btn : "QR kodu",
            negative_btn : "Manuel yöntem"
        },
        errors : {
            unknownError : "Bilinmeyen bir hata oluştu",
            noListDataFound : "Hata : LİSTE VERİLERİ BULUNAMADI!! VARSAYILAN LMRA'YA DÖNÜŞ",
            noDefaultListFound: 'Varsayılan liste yok! VARSAYILAN LMRA Kullanılıyor!',
        }
    },
    customLmraLists : {
        buildingListTitle : "LMRA formunuzu oluşturmak çok uzun sürmemeli.",
        criticalErrorTitle: 'Hata:',
        criticalErrorBody: 'LMRA formunuzu oluştururken bir şeyler ters gitti! Şimdi varsayılan LMRA\'yı yükleyeceğiz! lütfen yöneticinize aşağıdaki hata kodunu sağlayın : ',
    },
    workSessions :{
        global : {
            expiredLabel : "Süresi"
        },
        resumeSessionDialog : {
            titleActiveSession : "Aktif Oturum Bulundu",
            titleActiveSessionExpired : "(Süresi Dolmuş) Etkin Oturum Bulundu",
        },
        workSessionServiceNaDialog :{
            title : 'ÇALIŞMA HİZMETİ KULLANILAMIYOR',
            body : 'Üzgünüz, açık bir oturumunuz olup olmadığını belirleyemedik<br/><br/>' +
                '<b>LMRA Modülü kilitli: oturumu başlatamaz veya kapatamazsınız. </b><br/> Ancak yine de olay raporları gönderebilirsiniz (oturum dışında)<br/>' +
                "Oturum hizmeti kullanılabilir olduğunda bir bildirim alacaksınız<br/><br/>" +
                'bu hata devam ederse lütfen yöneticinize haber verin..'
        },
        lmraLocked : {
            lmraComponentLockedInfo : "Üzgünüm: <b>LMRA Modülü şu anda kilitli: oturum başlatamaz veya kapatamazsınız.</b>"
        },
        lmraVariants : {
            errors : {
                saving_session : {
                    missing_session_data : 'Sunucu yanıtı, oturum verilerini içermiyor',
                    could_not_save_session :'Oturum verileri yerel olarak kaydedilemedi...',
                    invalid_session_data : 'Oturum verileri geçersiz, veriler bozuk olabilir'
                }
            }
        }
    },
    whatsAppGroup : {
        errors : {
            unknown : "Bilinmeyen bir hata oluştu",
            notFound : "Grup kodu bulunamadı."
        }
    },
    emergency_numbers: {
        default_number_btn_txt: "Varsayılan Acil Durum Numarası",
        getting_data_title: "Son sayılar alınıyor"
    },
    checklist_components :{
        main_checklist_component : {
            tabs : {
                active_checklist : "Etkin Listesi",
                other_checklists : "Diğer Listeleri"
            }
        },
        checklist_detail_component : {
            toolbar:{
                title : "Görüntüleniyor : "
            },
            warning_message : "Mevcut aktif liste olmayan bir kontrol listesini görüntülüyorsunuz. Aktif listeyi görüntülemek için üst kısımdaki \"Aktif kontrol listesi\" sekmesini kullanın"
        }
    },
    version_info : {
        update : {
            version_up_to_date : "Sürüm güncel",
            version_minor_update : "Daha yeni bir sürüm mevcut (kiracınız için mevcut olmayabilir)",
            update_required : "Uyarı! Bu uygulama güncel değil, uygulamanın otomatik olarak güncellenmesi gerekiyor. Bu mesaj devam ederse yöneticiyle iletişime geçin."
        }
    },
    risk_reflex_qr_code_scanner : {
        overlay_view : {
            errors : {
                wrong_qr_code_type : {
                    title : "Yanlış QR kodu türü",
                    body : "Bu QR kod türü burada desteklenmiyor"
                },
                wrong_tenant : {
                    title : "Yanlış Kiracı",
                    body : "Bu QR kodu şirketiniz tarafından kullanılamaz"
                },
                invalid_qr_code : {
                    title : "Geçersiz QR kodu",
                    body : "Bu geçerli bir Risk Refleks QR kodu değil ve kullanılamaz"
                },
                invalid_qr_data : {
                    title : "Geçersiz QR kodu verileri",
                    body : "Bu QR kodu çevrilemiyor, QR kodu bozuk olabilir"
                }
            },
            title : "Risk-Reflex QR Kodunu Tarayın",
            info_manual: 'Taramada sorun mu yaşıyorsunuz? Manuel girişi kullan',
            manual_btn: "Manuel moda geç"
        }
    },
    project_documentation: {
        documentation_list : {
            getting_data_title : "Proje dokümantasyonu sunucudan alınıyor.",
            no_documentation_found : "Bu Proje için herhangi bir doküman bulunamadı.",
            errors : {
                could_not_load_documentation : "Dokümantasyon alınırken bir sorun oluştu, lütfen daha sonra tekrar deneyin."
            }
        }
    }
}